import { baseEnvironment, buildEnvironment } from './environment.interface';

export const environment = buildEnvironment(baseEnvironment, {
	baseUrl: 'https://test.klifdweb.de/',
	auth: {
		scopes: ['api://65b859dd-2474-4366-9ff7-f55c910f9b1e/Sample.Req'],
		clientId: '65b859dd-2474-4366-9ff7-f55c910f9b1e',
		authority: 'https://testklifdweb.ciamlogin.com/76242add-5a9e-4501-a1ad-7e37adf3849e/v2.0',
		knownAuthorities: ['testklifdweb.ciamlogin.com'],
		redirectUri: '/',
		postLogoutRedirectUri: '/',
	},
	appInsightsConnectionString:
		'InstrumentationKey=69d4f3c6-a8d0-4430-9e83-9de2075813df;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=13934a20-ee3f-4217-a0d8-b60a43c3fc79',
	showDevTools: false,
});
